import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from "prop-types";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Box from "@material-ui/core/Box";
import Button from "web/components/Button";
import NotificationBox from "./NotificationBox";
import AlertModal from 'web/components/AlertModal';
import Spinner from "web/components/Spinner";
import { notificationMarkReadApiV2, notificationClearApiV2 } from 'redux/actions/notification';
import { ContainerWrapper, UnTab, InnerTab } from "./NotificationStyled"

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  sideTabs: {
    width: "100%",
  },
}));

export default function NotificationVerticalTabs({
  notificationResponse,
  notificationPageData,
  notificationPageDataInfo,
  ...props
}) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const token = localStorage.getItem('token');
  const dispatch = useDispatch();
  let history = useHistory();
  const [loader, setLoader] = useState(false)
  const storedData = useSelector((state) => state.storedData.payload);
  let disableFlg = storedData?.guestUser

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);

  const handleChange = (event, newValue) => setValue(newValue)
  const [selectedTab, setSelectedTab] = useState('ALL');

  const notificationReadAllFunction = async () => {
    setLoader(true)
    let actionTypeValue = selectedTab
    if (selectedTab == 'BID' || selectedTab == 'ALT_BID') actionTypeValue = 'LOAD'
    if (selectedTab == 'OFFER' || selectedTab == 'ALT_OFFER' || selectedTab == 'BUY_NOW_DEL' || selectedTab == 'BUY_NOW_PICKUP') actionTypeValue = 'INVENTORY'
    let requestTypeValue = null
    if (selectedTab == 'BID') requestTypeValue = 'BID'
    else if (selectedTab == 'ALT_BID') requestTypeValue = 'ALTBID'
    else if (selectedTab == 'OFFER') requestTypeValue = 'BID'
    else if (selectedTab == 'ALT_OFFER') requestTypeValue = 'OFFER'
    else if (selectedTab == 'BUY_NOW_DEL') requestTypeValue = 'BUYNOW'
    else if (selectedTab == 'BUY_NOW_PICKUP') requestTypeValue = 'BUYNOWCPU'
    let data = {
      notificationId: null,
      actionType: actionTypeValue,
      requestType: requestTypeValue
    }
    let response = await dispatch(notificationMarkReadApiV2(data, token))
    setLoader(false)
    if (response.success) props.fetchSelectedPageData(selectedTab, 1)
    else {
      if (response.statusCode === 401) {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again in sometime.');
        setModalLink('');
        toggleModal();
      }
    }
  }

  const notificationClearAllApi = async () => {
    setLoader(true)
    let actionTypeValue = selectedTab
    if (selectedTab == 'BID' || selectedTab == 'ALT_BID') actionTypeValue = 'LOAD'
    if (selectedTab == 'OFFER' || selectedTab == 'ALT_OFFER' || selectedTab == 'BUY_NOW_DEL' || selectedTab == 'BUY_NOW_PICKUP') actionTypeValue = 'INVENTORY'
    let requestTypeValue = null
    if (selectedTab == 'BID') requestTypeValue = 'BID'
    else if (selectedTab == 'ALT_BID') requestTypeValue = 'ALTBID'
    else if (selectedTab == 'OFFER') requestTypeValue = 'BID'
    else if (selectedTab == 'ALT_OFFER') requestTypeValue = 'OFFER'
    else if (selectedTab == 'BUY_NOW_DEL') requestTypeValue = 'BUYNOW'
    else if (selectedTab == 'BUY_NOW_PICKUP') requestTypeValue = 'BUYNOWCPU'
    let data = {
      notificationId: null,
      actionType: actionTypeValue,
      requestType: requestTypeValue
    }
    let response = await dispatch(notificationClearApiV2(data, token))
    setLoader(false)
    if (response.success) props.fetchSelectedPageData(selectedTab, 1)
    else {
      if (response.statusCode === 401) {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again in sometime.');
        setModalLink('');
        toggleModal();
      }
    }
  }

  return (
    <ContainerWrapper>
      {loader && <Spinner />}
      <div className="button-wrapper">
        <div className='btn1'>
          <Button
            type="app-green-button"
            handleClick={() => notificationClearAllApi()}
          >
            Clear All
          </Button>
        </div>
        <div className="btn2">
          <Button
            type="app-green-button"
            handleClick={() => notificationReadAllFunction()}
          >
            Mark as Read
          </Button>
        </div>
      </div>
      <div className="notification-sec post-accordion">
        <Tabs
          orientation="vertical"
          initialSelectedIndex={value}
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          className={classes.tabs}
        >
          <UnTab
            style={{ padding: "10px 0px 15px 20px" }}
            className={selectedTab === 'ALL' ? "active" : ""}
            onClick={() => {
              setSelectedTab('ALL')
              if (selectedTab !== 'ALL') props.fetchSelectedPageData('ALL', 1)
            }}
          >
            All
            {notificationResponse?.allNotificationsCount > 0 ? (<span className="notification">{notificationResponse?.allNotificationsCount}<span className="bg"></span></span>) : (<></>)}
          </UnTab>
          <UnTab
            style={{ padding: "10px 0px 15px 20px" }}
            className={selectedTab === 'ORDER' ? "active" : ""}
            onClick={() => {
              setSelectedTab('ORDER')
              if (selectedTab !== 'ORDER') props.fetchSelectedPageData('ORDER', 1)
            }}
          >
            Orders
            {notificationResponse?.orderNotificationsCount > 0 ? (<span className="notification">{notificationResponse?.orderNotificationsCount}<span className="bg"></span></span>) : (<></>)}
          </UnTab>
          <UnTab
            style={{ padding: "10px 0px 15px 20px", opacity: !disableFlg ? 1 : 0.5 }}
            className={selectedTab === 'NETWORK' ? "active" : ""}
            onClick={() => {
              if (!disableFlg) {
                setSelectedTab('NETWORK')
                if (selectedTab !== 'NETWORK') props.fetchSelectedPageData('NETWORK', 1)
              }
            }}
          >
            My Community
            {notificationResponse?.myCommunityNotificationsCount > 0 ? (<span className="notification">{notificationResponse?.myCommunityNotificationsCount}<span className="bg"></span></span>) : (<></>)}
          </UnTab>

          <UnTab
            style={{ padding: "10px 0px 15px 20px" }}
            className={selectedTab === 'CLAIM_RESOLUTION' ? "active" : ""}
            onClick={() => {
              setSelectedTab('CLAIM_RESOLUTION')
              if (selectedTab !== 'CLAIM_RESOLUTION') props.fetchSelectedPageData('CLAIM_RESOLUTION', 1)
            }}
          >
            Resolution Center
            {notificationResponse?.resolutionCenterCount > 0 ? (<span className="notification">{notificationResponse?.resolutionCenterCount}<span className="bg"></span></span>) : (<></>)}
          </UnTab>

          <UnTab
            style={{ padding: "10px 0px 15px 20px" }}
            className={selectedTab === 'PICKUP' ? "active" : ""}
            onClick={() => {
              setSelectedTab('PICKUP')
              if (selectedTab !== 'PICKUP') props.fetchSelectedPageData('PICKUP', 1)
            }}
          >
            Pickup Orders
            {notificationResponse?.pickupCount > 0 ? (<span className="notification">{notificationResponse?.pickupCount}<span className="bg"></span></span>) : (<></>)}
          </UnTab>

          <Accordion>
            <AccordionSummary
              onClick={() => {
                setSelectedTab('LOAD')
                if (selectedTab !== 'LOAD') props.fetchSelectedPageData('LOAD', 1)
              }}
              className={selectedTab === 'LOAD' ? "active" : ""}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography>
                {notificationResponse ? (
                  <div onClick={() => { }}>Need</div>
                ) : (<></>)}
                {notificationResponse?.postNeedNotifications?.needNotificationsCount > 0 ? (<span className="notification">{notificationResponse?.postNeedNotifications?.needNotificationsCount}<span className="bg"></span></span>) : (<></>)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className="inner-tab-wrapper">
                <InnerTab>
                  {!disableFlg ? <>
                    {notificationResponse ? (
                      <div
                        className={selectedTab === 'BID' ? "active inner-text" : "inner-text"}
                        onClick={() => {
                          setSelectedTab('BID')
                          if (selectedTab !== 'BID') props.fetchSelectedPageData('BID', 1)
                        }}
                      >
                        Bid
                      </div>
                    ) : (
                      <></>
                    )}
                    {notificationResponse?.postNeedNotifications?.needBidNotificationsCount > 0 ? (<span className="notification">{notificationResponse?.postNeedNotifications?.needBidNotificationsCount}<span className="bg"></span></span>) : (<></>)}
                  </> : <>
                    <div style={{ "opacity": "0.5" }}
                      className={"inner-text"}
                    >
                      Bid
                    </div>
                  </>}
                </InnerTab>

                <InnerTab>
                  {!disableFlg ? <>
                    {notificationResponse ? (
                      <div
                        className={selectedTab === 'ALT_BID' ? "active inner-text" : "inner-text"}
                        onClick={() => {
                          setSelectedTab('ALT_BID');
                          if (selectedTab !== 'ALT_BID') props.fetchSelectedPageData('ALT_BID', 1)
                        }}
                      >
                        Alt Bid
                      </div>
                    ) : (
                      <span></span>
                    )}
                    {notificationResponse?.postNeedNotifications?.needAltBidNotificationsCount > 0 ? (<span className="notification">{notificationResponse?.postNeedNotifications?.needAltBidNotificationsCount}<span className="bg"></span></span>) : (<></>)}
                  </> :
                    <div style={{ "opacity": "0.5" }}
                      className={"inner-text"}
                      onClick={() => {
                        setSelectedTab('ALT_BID');
                      }}
                    >
                      Alt Bid
                    </div>}
                </InnerTab>
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              className={selectedTab === 'INVENTORY' ? "active" : ""}
              onClick={() => {
                setSelectedTab('INVENTORY')
                if (selectedTab !== 'INVENTORY') props.fetchSelectedPageData('INVENTORY', 1)
              }}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography>
                {notificationResponse ? (
                  <div onClick={() => { }}>
                    Inventory
                  </div>
                ) : (<span></span>)}
                {notificationResponse?.postInventoryNotifications?.invNotificationsCount > 0 ? (<span className="notification">{notificationResponse?.postInventoryNotifications?.invNotificationsCount}<span className="bg"></span></span>) : (<></>)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className="inner-tab-wrapper">
                <InnerTab>
                  {notificationResponse ? (
                    <div
                      className={selectedTab === 'OFFER' ? "active inner-text" : "inner-text"}
                      onClick={() => {
                        setSelectedTab('OFFER')
                        if (selectedTab !== 'OFFER') props.fetchSelectedPageData('OFFER', 1)
                      }}
                    >
                      Offer
                    </div>
                  ) : (
                    <span></span>
                  )}
                  {notificationResponse?.postInventoryNotifications?.invOfferNotificationsCount > 0 ? (<span className="notification">{notificationResponse?.postInventoryNotifications?.invOfferNotificationsCount}<span className="bg"></span></span>) : (<></>)}
                </InnerTab>
                <InnerTab>
                  {notificationResponse ? (
                    <div
                      className={selectedTab === 'ALT_OFFER' ? "active inner-text" : "inner-text"}
                      onClick={() => {
                        setSelectedTab('ALT_OFFER')
                        if (selectedTab !== 'ALT_OFFER') props.fetchSelectedPageData('ALT_OFFER', 1)
                      }}
                    >
                      Alt Offer
                    </div>
                  ) : (
                    <span></span>
                  )}
                  {notificationResponse?.postInventoryNotifications?.invAltOfferNotificationsCount > 0 ? (<span className="notification">{notificationResponse?.postInventoryNotifications?.invAltOfferNotificationsCount}<span className="bg"></span></span>) : (<></>)}
                </InnerTab>
                <InnerTab>
                  {notificationResponse ? (
                    <div
                      className={selectedTab === 'BUY_NOW_DEL' ? "active inner-text" : "inner-text"}
                      onClick={() => {
                        setSelectedTab('BUY_NOW_DEL')
                        if (selectedTab !== 'BUY_NOW_DEL') props.fetchSelectedPageData('BUY_NOW_DEL', 1)
                      }}
                    >
                      Buy Now Delivery
                    </div>
                  ) : (
                    <span></span>
                  )}
                  {notificationResponse?.postInventoryNotifications?.invBuyNowNotificationsCount > 0 ? (<span className="notification">{notificationResponse?.postInventoryNotifications?.invBuyNowNotificationsCount}<span className="bg"></span></span>) : (<></>)}
                </InnerTab>
                <InnerTab>
                  {notificationResponse ? (
                    <div
                      className={selectedTab === 'BUY_NOW_PICKUP' ? "active inner-text" : "inner-text"}
                      onClick={() => {
                        setSelectedTab('BUY_NOW_PICKUP')
                        if (selectedTab !== 'BUY_NOW_PICKUP') props.fetchSelectedPageData('BUY_NOW_PICKUP', 1)
                      }}
                    >
                      Buy Now Pickup
                    </div>
                  ) : (
                    <span></span>
                  )}
                  {notificationResponse?.postInventoryNotifications?.invBuyNowPickupNotificationsCount > 0 ? (<span className="notification">{notificationResponse?.postInventoryNotifications?.invBuyNowPickupNotificationsCount}<span className="bg"></span></span>) : (<></>)}
                </InnerTab>
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Tabs>

        <div className={classes.sideTabs}>
          {notificationPageData && (
            <NotificationBox
              notificationPageData={notificationPageData}
              notificationPageDataInfo={notificationPageDataInfo}
              selectedType="notifications"
              selectedTab={selectedTab}
              requestType=""
              fetchDataCallBack={(pageNo) => {
                props.fetchSelectedPageData(selectedTab, pageNo)
              }}
            />
          )}
        </div>
      </div>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=''
        content={modalContent}
        link={modalLink}
      />
    </ContainerWrapper>
  );
}